import { ArrowRight } from "lucide-react";
import Reveal, { SectionLabel } from "./Reveal";
import { WHATSAPP_URL } from "@/lib/scroll";

const CONDITIONS = [
  "dores de cabeça e enxaqueca frequentes",
  "distúrbios do sono e insônia",
  "dificuldade de memória e concentração",
  "tontura",
  "dormência em alguma parte do corpo",
  "cansaço que não passa",
  "AVC",
];

export default function QuandoProcurar() {
  return (
    <section id="quando" className="bg-cream py-28 md:py-36">
      <div className="mx-auto max-w-[1240px] px-5 md:px-10">
        <SectionLabel n="05">Sinais de alerta</SectionLabel>
        <Reveal delay={0.08}>
          <h2 className="mt-8 max-w-3xl font-display font-medium text-[clamp(2rem,4.2vw,3.6rem)] leading-[1.08] tracking-[-0.01em]">
            Você deve procurar uma ajuda neurológica{" "}
            <em className="font-serifd italic text-terra">se tem/teve:</em>
          </h2>
        </Reveal>

        <Reveal delay={0.16}>
          <ul className="mt-12 flex flex-wrap gap-3.5" data-testid="quando-chips">
            {CONDITIONS.map((c) => (
              <li
                key={c}
                className="flex items-center gap-3 rounded-full border border-olive/25 bg-cream px-6 py-3.5 text-base md:text-lg font-medium text-olive transition-all duration-300 hover:-translate-y-0.5 hover:border-olive hover:bg-olive hover:text-cream cursor-default"
              >
                <span className="size-2 rounded-full bg-terra" />
                {c}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.22}>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="quando-cta-whatsapp"
            className="group mt-12 inline-flex items-center gap-4 font-display text-2xl md:text-3xl font-medium text-olive transition-colors hover:text-terra"
          >
            Agendar avaliação
            <span className="inline-flex size-12 items-center justify-center rounded-full bg-terra text-cream transition-transform duration-300 group-hover:translate-x-2">
              <ArrowRight className="size-5" />
            </span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
